




















































































import { Vue, Component, Ref } from "vue-property-decorator";
import request from "@/api/index";
import wang from "@/components/wang.vue";
import {
  Icon,
  Form,
  Field,
  Button,
  Radio,
  RadioGroup,
  CellGroup,
  Cell,
  DropdownMenu,
  DropdownItem,
  ActionSheet,
  ImagePreview,
  Toast
} from "vant";
import Native from "@/common/Native";
import store from "@/store";
@Component({
  components: {
    "van-icon": Icon,
    "van-button": Button,
    "van-form": Form,
    "van-field": Field,
    "van-radio": Radio,
    "van-radio-group": RadioGroup,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-dropdown-menu": DropdownMenu,
    "van-dropdown-item": DropdownItem,
    "van-action-sheet": ActionSheet,
    wang
  }
})
export default class PersonalRelease extends Vue {
  demoPics = [
    require("@/assets/images/personal-release/demo.png"),
    require("@/assets/images/personal-release/demo1.jpg"),
    require("@/assets/images/personal-release/demo2.jpg")
  ];
  // 富文本内容
  content = "";
  // 富文本编辑器事件回调
  wangEditorChange(e: any) {
    //返回html格式
    this.content = e;
  }

  @Ref("formRef")
  formRef!: HTMLDivElement;

  // 表单数据
  formState = {
    title: "",
    listViewType: 0,
    contextType: "0",
    listImgUrl: []
  };

  // 列表展示类型面板控制器
  displayTypeActionShow = false;
  // 列表展示类型面板控制器的options
  actions = [
    { name: "无图", key: 0 },
    { name: "单图", key: 1 },
    { name: "大图", key: 2 },
    { name: "多图", key: 3 }
  ];
  // 列表展示类型面板选中事件回调
  onDisplayTypeSelect(item: { name: string; key: number }) {
    this.formState.listViewType = item.key;
    // 如果列表展示类型为无图,则清空formState.img = []
    if (item.key === 0) {
      this.formState.listImgUrl = [];
    } else if (item.key === 1 || item.key === 2) {
      // 如果列表展示类型为单图或者大图，则formState.imgs只保留第一张图片
      this.formState.listImgUrl.splice(1, this.formState.listImgUrl.length - 1);
    }
    this.displayTypeActionShow = false;
  }

  // 获取列表展示类型名称
  getDisplayTypeName(key: number) {
    const result = this.actions.find(
      (action: { name: string; key: number }) => {
        return action.key === key;
      }
    );
    if (result) {
      return result.name;
    }
  }

  // 是否展示上传图标
  get uploadShow() {
    // 如果是无图，不展示上传图标
    if (this.formState.listViewType === 0) {
      return false;
    } else if (
      // 如果是单图或者大图，则只允许上传一张图片
      this.formState.listViewType === 1 ||
      this.formState.listViewType === 2
    ) {
      return this.formState.listImgUrl.length < 1;
    } else if (this.formState.listViewType === 3) {
      // 如果是多图，则只允许至多上传3张图片
      return this.formState.listImgUrl.length < 3;
    }
  }
  // 删除图片
  onDeleteImg(item: string) {
    const index = this.formState.listImgUrl.findIndex((url: string) => {
      return url === item;
    });
    if (index !== -1) {
      this.formState.listImgUrl.splice(index, 1);
    }
  }

  // 预览图片
  onImgPreview(item: string) {
    const index = this.formState.listImgUrl.findIndex((url: string) => {
      return url === item;
    });
    if (index !== -1) {
      ImagePreview({
        images: this.formState.listImgUrl,
        startPosition: index
      });
    }
  }

  // 调用原生上传图片
  uploadImg() {
    let max = 1;
    // 如果为列表显示类型为多图
    if (this.formState.listViewType === 3) {
      max = 3 - this.formState.listImgUrl.length;
    }
    if (Native.isOpenInApp()) {
      const result = this.callBack("uploadOver");
      window.ZWY_CLOUD.appUpload({
        callback: "uploadOver",
        num: max
      });
      result.then((res: any) => {
        const imgArr: never[] = res.split(",");
        this.formState.listImgUrl.push(...imgArr);
      });
    } else {
      const temp: never[] = [
        this.demoPics[this.formState.listImgUrl.length]
      ] as never[];
      this.formState.listImgUrl.push(...temp);
    }
  }

  // 端内关闭当前web-view窗口
  appCloseWeb() {
    if (Native.isOpenInApp()) {
      setTimeout(() => {
        window.ZWY_CLOUD.appCloseWeb({
          type: 1
        });
      }, 1000);
    }
  }

  // 与APP通信，挂载回调
  callBack(funName: string) {
    return new Promise((resolve, reject) => {
      (window as any)[funName] = (result: any) => {
        if (typeof result === "string") {
          try {
            result = JSON.parse(result);
            resolve(result);
          } catch (e) {
            resolve(result);
          }
        }
      };
    });
  }

  // 发布稿子
  onSubmit() {
    // 推迟提交的执行时机，保证富文本编辑器成功给 this.content 赋值
    setTimeout(async () => {
      if (!this.formState.title) {
        Toast("请继续完善您的发布内容！");
        return;
      }
      // 如果选择列表展示类型为单图或者大图，则务必要上传一张图片
      if (
        (this.formState.listViewType === 1 ||
          this.formState.listViewType === 2) &&
        this.formState.listImgUrl.length <= 0
      ) {
        Toast("请上传一张列表图");
        return;
      }
      // 如果选择列表展示类型为多图，则务必要上传三张图片
      if (
        this.formState.listViewType === 3 &&
        this.formState.listImgUrl.length < 3
      ) {
        Toast("请上传三张列表图");
        return;
      }
      if (!this.content) {
        Toast("请继续完善您的发布内容");
        return;
      }

      let obj = {
        appId: "28",
        token: this.$store.state.token,
        title: this.formState.title,
        listViewType: this.formState.listViewType,
        listImgUrl: this.formState.listImgUrl.join(","),
        contextType: this.formState.contextType,
        content: this.content
      };
      const res = await request.postRelease(obj);
      if (res.code === 0) {
        Toast.success("发布成功");
        this.appCloseWeb();
      } else {
        Toast.fail(res.message);
      }
    }, 200);
  }

  // 取消按钮点击事件回调
  onCancel() {
    this.appCloseWeb();
  }

  // 充值表单数据
  reset() {
    this.formState.title = "";
    this.formState.listViewType = 0;
    this.formState.listImgUrl = [];
    this.content = "";
  }

  async created() {
    document.title = "个人号发稿";
    if (Native.isOpenInApp()) {
      const userInfo = await Native.getUserInfo();
      store.commit("SET_STATE", { token: userInfo.token });
    }
  }
  mounted() {}
}
